import { cn } from '../lib/utils';
import { Avatar, AvatarFallback, AvatarImage } from '../shadcn/avatar';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../shadcn/tooltip';

type SessionProps = {
  displayName: string | null;
  pictureUrl?: string | null;
};

type TextProps = {
  text: string;
};

type ProfileAvatarProps = (SessionProps | TextProps) & {
  className?: string;
  fallbackClassName?: string;
};
/**
 * When used inside of a project (under [account]) please use the `UserAvatar` component from `@kit/team-accounts` instead
 */
export function ProfileAvatar(props: ProfileAvatarProps) {
  const avatarClassName = cn(
    'size-8',
    props.className,
    'mx-auto group-focus:ring-2',
  );

  if ('text' in props) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Avatar className={avatarClassName}>
              <AvatarFallback
                className={cn(
                  props.fallbackClassName,
                  'animate-in fade-in uppercase',
                )}
              >
                {props.text.slice(0, 1)}
              </AvatarFallback>
            </Avatar>
          </TooltipTrigger>
          <TooltipContent>
            <p>{props.text}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  const initials = props.displayName?.slice(0, 1);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Avatar className={avatarClassName}>
            <AvatarImage src={props.pictureUrl ?? undefined} />
            <AvatarFallback
              className={cn(props.fallbackClassName, 'animate-in fade-in')}
            >
              <span suppressHydrationWarning className={'uppercase'}>
                {initials}
              </span>
            </AvatarFallback>
          </Avatar>
        </TooltipTrigger>
        <TooltipContent>
          <p>{props.displayName}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
